export enum DocumentTextMode {
	MINIMAL = 'MINIMAL',
	FULL = 'FULL'
}